import ApiService from '../api.service';

const UsersResource = {
  login: (params) => ApiService.post('v1/users/sign_in', params),
  recoverPassword: (params) => ApiService.post('v1/users/reset_password', params),
  fbLogin: (params) => ApiService.post('v1/users/facebook_auth', params),
  googleLogin: (params) => ApiService.post('v1/users/google_auth', params),
  appleLogin: (params) => ApiService.post('v1/users/apple_auth', params),
  show: () => ApiService.get('v1/users/me'),
  register: (params) => ApiService.post('v1/users', params),
  createEmailToken: (params) => ApiService.post('v1/users/create_user_email', params),
  acceptTerms: (params) => ApiService.put('v1/users/accept_terms', params),
  acceptPrivacyPolicy: (params) => ApiService.put('v1/users/accept_privacy_policy', params),
  validateEmailToken: (params) => ApiService.post('v1/users/validate_email_token', params),
  sendTwoFactorCode: (params) => ApiService.post('v1/users/send_two_factor_code', params),
  verifyTwoFactorCode: (params) => ApiService.post('v1/users/verify_two_factor_code', params),
};

export default UsersResource;
